import { useCard } from "cards/provider";
import { CardItem } from "cards/types";
import FilteredTable from "components/FilteredTable";
import { useEffect, useRef } from "react";
import columns from "./columns";
import filters from "./filters";
import { IAtp } from "./types";


export default function Atp() {
  const { openCard } = useCard();
  const tableRef = useRef(null)

  useEffect(() => {
    function cardUpdated(e: any) {
      const message = e.detail as CardItem
      if (message.type === "atp") {
        (tableRef.current as any).reload()
      }
    }
    document.addEventListener('card:changed', cardUpdated);
    return () => {
      document.removeEventListener('card:changed', cardUpdated);
    }
  }, [])

  return (
    <div>
      <FilteredTable
        dataURL="/atp/atp/"
        columns={columns}
        filters={filters}
        userSettingsKey={"admin-atp"}
        onRowClick={(atp: IAtp) => {
          openCard("atp", atp.id)
        }}
        tableRef={tableRef}
      />
    </div>
  )
}